import _ from "lodash";
import DetailPageDescComponent from "../../Misc/DetailPageDesc/DetailPageDescComponent";
import DetailPageTitleComponent from "../../Misc/DetailPageTitle/DetailPageTitleComponent";
import TitleLogoComponent from "../../Misc/TitleLogo/TitleLogoComponent";
import TitleTagsComponent from "../../Misc/TitleTags/TitleTagsComponent";
import RPLeftPanelComponent from "../RPLeftPanelComponent/RPLeftPanelComponent";
import RPRightPanelComponent from "../RPRightPanelComponent/RPRightPanelComponent";
import "./RPDetailBodyComponent.scss";
import { useState, useEffect } from "react";
import RolePlayReviewDetailComponent from "../RolePlayReviewDetailComponent";
import MyRolePlayReviewDetailComponent from "../MyRolePlayReviewDetailComponent";
import MyRoleplayDraftComponent from "../MyRoleplayDraftComponent";

const RPDetailBodyComponent = (props) => {
  const {
    id,
    title,
    logoURL,
    tagsArray,
    description,
    isLoading,
    setIsLoading,
    setLoaderMsg,
    productData,
    rpData,
    setShowModalMsg,
    setConfirmModal,
    setShowGreenTick,
    rp_mid,
  } = props;

  const [reload, setReload] = useState(false);

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const submit_id = params.get("submit_id");

  const [isCardClick, setIsCardClick] = useState("");
  const [submitId, setSubmitId] = useState("");
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    if (_.toNumber(submitId)) {
      setIsCardClick("uploaded");
    }
  }, [submitId]);

  useEffect(() => {
    setSubmitId(submit_id)
  }, [submit_id]);
  useEffect(() => {
    console.log("submit-id", submitId,submit_id);
  }, [submitId, isCardClick, showVideo]);

  console.log("rp-data", rpData);
  return (
    <>
      <div className="row rp-detail">
        <div className="col-md-8 col-sm-12">
          <div className="left-panel">
            <div className="module-learn-text mt-0">
              <DetailPageTitleComponent title={title} isLoading={isLoading} />
              <div className="d-flex box-meta">
                <div className="img-box-meta">
                  <TitleLogoComponent
                    logoURL={logoURL}
                    altText={title}
                    isLoading={isLoading}
                  />
                </div>
                <div className="meta-lsit">
                  <TitleTagsComponent
                    tagsArray={tagsArray}
                    isLoading={isLoading}
                  />
                </div>
              </div>
              <DetailPageDescComponent
                desc={description}
                isLoading={isLoading}
              />
              <div className="learn-discuss-section">
                {(!_.isEmpty(productData) &&
                  isCardClick != "uploaded" &&
                  isCardClick != "drafted") ||
                showVideo ? (
                  <RPLeftPanelComponent
                    id={id}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    setLoaderMsg={setLoaderMsg}
                    productData={productData}
                    rpData={rpData}
                    setShowModalMsg={setShowModalMsg}
                    setConfirmModal={setConfirmModal}
                    setShowGreenTick={setShowGreenTick}
                    setReload={setReload}
                  />
                ) : isCardClick === "uploaded" ? (
                  <MyRolePlayReviewDetailComponent
                    role_type={"reviewed"}
                    submitId={submitId}
                    setShowVideo={setShowVideo}
                  />
                ) : isCardClick === "drafted" ? (
                  <MyRoleplayDraftComponent
                    role_type={"reviewe"}
                    submitId={submitId}
                    setShowVideo={setShowVideo}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-4 col-sm-12">
          <RPRightPanelComponent
            video_id={rp_mid}
            reload={reload}
            setReload={setReload}
            isCardClick={isCardClick}
            setIsCardClick={setIsCardClick}
            setSubmitId={setSubmitId}
            setShowVideo={setShowVideo}
          />
        </div>
      </div>
    </>
  );
};

export default RPDetailBodyComponent;
